import { State } from "easy-peasy";
import { RootState } from "../../../store/storeModel";

export const isAuthenticated = (state: State<RootState>): boolean => {
    return !!state.auth.currentUser;
};
